import React, { useState } from 'react';

import { Tabs } from 'components/Tabs';
import { Create } from './Create';
import { JobHistory } from './JobHistory';
import { ScheduledJobs } from './ScheduledJobs';
import { useTabs } from './hooks';
import { TabOptions } from 'types/ManageJobs';

import {
  ManageJobsContent,
  ManageJobs as ManageJobsStyled,
  ManageJobsTable,
  TimeZoneInfo,
  Title,
} from './ManageJobsStyles';
import { useHistory } from 'react-router-dom';
import { paths } from 'routes';
import { GetTimeZone } from 'modules/Benchmarks/BenchmarkList/utils';

type Props = {
  show: boolean;
  handleClose: () => void;
};

const tabOptions: string[] = [
  TabOptions.Create,
  TabOptions.ScheduledJobs,
  TabOptions.JobHistory,
];

export const ManageJobs: React.FC<Props> = () => {
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);
  const {
    activeTab,
    setActiveTab,
    showScheduledJobsTab,
    showCreateTab,
    showJobHistoryTab,
  } = useTabs(TabOptions.Create);
  const history = useHistory();

  const handleEditJog = (id: string) => {
    setSelectedJobId(id);
    setActiveTab(TabOptions.Create);
  };

  const onClose = () => {
    history.replace(paths.benchmarks);
  };

  return (
    <>
      <ManageJobsStyled>
        <Title>Manage Jobs</Title>
        {activeTab === TabOptions.JobHistory && (
          <TimeZoneInfo>Time displayed in {GetTimeZone()}</TimeZoneInfo>
        )}
        <Tabs
          list={tabOptions}
          onChange={(e: any) => {
            setSelectedJobId(null);
            setActiveTab(e);
          }}
          active={activeTab}
        />
        <ManageJobsContent>
          {showCreateTab && <Create id={selectedJobId} onClose={onClose} />}
          <ManageJobsTable>
            {showScheduledJobsTab && (
              <ScheduledJobs edit={handleEditJog} onClose={onClose} />
            )}
            {showJobHistoryTab && <JobHistory onClose={onClose} />}
          </ManageJobsTable>
        </ManageJobsContent>
      </ManageJobsStyled>
    </>
  );
};
